import { useState } from "react";
import { Dialog } from "primereact/dialog";

const BookCoverPreview = ({
	coverUrl,
	title,
	thumbnailWidth = 64,
	thumbnailHeight = 80,
	className = "",
}) => {
	const [showPreview, setShowPreview] = useState(false);
	const [imageError, setImageError] = useState(false);

	const handleImageClick = () => {
		if (coverUrl && !imageError) {
			setShowPreview(true);
		}
	};

	const handleImageError = () => {
		setImageError(true);
	};

	const handleHide = () => {
		setShowPreview(false);
	};

	return (
		<>
			<div
				className={`flex items-center justify-center ${className}`}
				onClick={handleImageClick}
				role="button"
				tabIndex={0}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						handleImageClick();
					}
				}}
			>
				{coverUrl && !imageError ? (
					<img
						src={coverUrl}
						alt={title}
						className="object-cover rounded shadow-sm cursor-pointer hover:opacity-80 hover:shadow-md transition-all duration-200"
						style={{ width: thumbnailWidth, height: thumbnailHeight }}
						onError={handleImageError}
					/>
				) : (
					<div
						className="bg-gray-200 rounded shadow-sm flex items-center justify-center"
						style={{ width: thumbnailWidth, height: thumbnailHeight }}
					>
						<span className="text-gray-500 text-xs text-center px-1">
							No Cover
						</span>
					</div>
				)}
			</div>

			<Dialog
				visible={showPreview}
				onHide={handleHide}
				header={title || "Book Cover"}
				className="book-cover-preview-dialog"
				style={{ width: "auto", maxWidth: "90vw" }}
				contentClassName="flex items-center justify-center p-4"
				dismissableMask
				draggable={false}
			>
				<div className="flex items-center justify-center">
					<img
						src={coverUrl}
						alt={title}
						className="object-cover rounded shadow-lg"
						style={{ width: 150, height: 230 }}
					/>
				</div>
			</Dialog>
		</>
	);
};

export default BookCoverPreview;
